var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("side-by-side-settings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      value: _vm.settings.RecordsPerColumn > 0,
                      label: _vm.$ct("side-by-side-enabled"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.toggle($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      disabled: _vm.disabled,
                      label: _vm.$ct("only-one-record-per-page"),
                    },
                    model: {
                      value: _vm.settings.OnlyOneRecordPerPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "OnlyOneRecordPerPage", $$v)
                      },
                      expression: "settings.OnlyOneRecordPerPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      disabled: _vm.disabled,
                      decimals: 0,
                      label: _vm.$ct("records-per-column"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.settings.RecordsPerColumn,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "RecordsPerColumn", $$v)
                      },
                      expression: "settings.RecordsPerColumn",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }